const HIDDEN_ADDRESS = "Address shared after you accept";

const clean = (value) => String(value ?? "").trim();

const sameUser = (a, b) => a !== undefined && a !== null && b !== undefined && b !== null && Number(a) === Number(b);

// IsAccept is authoritative when the endpoint returns it: a "not a fit" introduction keeps its Accept_Date.
const isAccepted = (details) =>
  details?.IsAccept !== undefined && details?.IsAccept !== null
    ? Number(details.IsAccept) === 1
    : Boolean(details?.Accept_Date);

const areaFromFields = (details) => {
  const stateAndZip = [clean(details?.State), clean(details?.ZIP ?? details?.PostalCode)].filter(Boolean).join(" ");
  return [clean(details?.City), stateAndZip].filter(Boolean).join(", ");
};

const areaFromLocation = (location) => {
  const parts = clean(location).split(",").map(clean).filter(Boolean);
  // "street[, unit], city, state zip": the area is always the last two parts.
  if (parts.length >= 3) return parts.slice(-2).join(", ");
  const withoutStreet = /^\d/.test(parts[0] || "") ? parts.slice(1) : parts;
  return withoutStreet.length > 1 ? withoutStreet.join(", ") : "";
};

export const introHeading = (details, viewerUserId) => {
  const location = clean(details?.Location);
  const isPrivateProperty = Boolean(details?.Inv_Id);
  if (!isPrivateProperty || isAccepted(details) || sameUser(viewerUserId, details?.Agent_User_Id)) {
    return location;
  }
  return areaFromLocation(location) || areaFromFields(details) || HIDDEN_ADDRESS;
};
